import Listing from "../lessons/Listing";
import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useParams } from "react-router-dom";
import { arr } from "../../routes/apiEndPoints";
import Loader from "../../components/other/Loader";
import HeroSection from "../../layout/HeroSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchList } from "../../redux/action/knowledgebaseAction";

const LexiconDynamicPage = () => {
  const { routeName } = useParams();
  const dispatch = useDispatch();
  const { list, isLoading } = useSelector(
    (state) => state?.knowledgebaseReducer
  );

  useEffect(() => {
    if (routeName) {
      dispatch(fetchList({ routeName }));
    }
  }, []);

  const getLabel = (route) => {
    const item = arr.find(({ path }) => path === route);
    return item ? item.label : "Page Not Found";
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection label={<h1 class="mb-3">{getLabel(routeName)}</h1>} />
        {getLabel(routeName) != "Page Not Found" && (
          <Listing contentData={list} color={"#36296c"} />
        )}
        <Footer />
      </div>
    </>
  );
};

export default LexiconDynamicPage;
